import axios from "axios";
import * as XLSX from "xlsx";
import moment from "moment";

export function downloadTrainingReport(selectedTraining) {
  axios.defaults.headers["Authorization"] = localStorage.getItem("token");

  axios
    .post(process.env.VUE_APP_BASE_PATH + "/trainings/get", {
      trainingIds: selectedTraining,
    })
    .then((response) => {
      // Handle multiple training reports
      const reports = Array.isArray(response.data)
        ? response.data
        : [response.data];

      let allParticipantsData = [];
      reports.forEach((report) => {
        const participantsData = report.listTrainees.map((trainee) => {
          return [
            report.training.title ?? "", // Training title (new first column)
            report.training.district?.province?.country?.title ?? "", // Country
            dateFormate(report.training.startdate), // start date
            dateFormate(report.training.enddate), // end date
            report.training.trainingTopic ?? "", // Event Topic
            report.training.trainingtype?.title ?? "", // Event Type
            combineTrainerNames(report.trainers), // Event Delivered By:
            report.training.venue ?? "", // Event Location
            trainee.name ?? "", // Participant Name
            trainee.contactNo ?? "", // Contact No
            trainee.cnic ?? "", // CNIC
            trainee.email ?? "", // Email
            trainee.department ?? "", // Department/Section
            trainee.sector ?? "", // Sector
            trainee.address ?? "", // Address
            trainee.district ?? "", // Distric
            trainee.gender ?? "", // Gender
            trainee.designation ?? "", //Designation
            preTestScore(trainee), //Pre-Test Score
            postTestScore(trainee), // Post-Test Score
            exhibitedBehavior(trainee), // Exhibited Behavior Change?
          ];
        });
        allParticipantsData = [...allParticipantsData, ...participantsData];
      });

      const data = [
        [
          "Event Title", // New header for first column
          "Country",
          "Start Date",
          "End Date",
          "Event Topic",
          "Event Type",
          "Event Delivered By:",
          "Event Location",
          "Participant Name",
          "Contact No",
          "CNIC",
          "Email",
          "Department/Section",
          "Sector",
          "Participant Address",
          "Participant District",
          "Gender",
          "Designation",
          "Pre-Test Score",
          "Post-Test Score",
          "Exhibited Behavior Change?",
        ],
        ...allParticipantsData,
      ];

      // Create a new workbook
      const wb = XLSX.utils.book_new();
      // Add a worksheet with the data
      const ws = XLSX.utils.aoa_to_sheet(data);
      // Apply filter to the worksheet
      ws["!autofilter"] = {
        ref: "A1:S1",
      }; // Assuming headers are in A1:F1
      // Append the worksheet to the workbook
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      // Generate a blob from the workbook
      const wbout = XLSX.write(wb, {
        bookType: "xlsx",
        type: "array",
      });
      const blob = new Blob([wbout], {
        type: "application/octet-stream",
      });
      // Create a temporary anchor element to trigger the download
      const a = document.createElement("a");
      document.body.appendChild(a);
      a.style.display = "none";
      // Set the download URL and click the anchor to trigger the download
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = "Event Report.xlsx";
      a.click();
      // Cleanup
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    });
}

function combineTrainerNames(trainersArray) {
  const trainerNames = trainersArray.map((trainer) => trainer.trainer.name);
  const combinedNames = trainerNames.join(",");
  return combinedNames;
}
// function combineTrainerId(trainersArray) {
//   const trainerNames = trainersArray.map((trainer) => trainer.trainer.id);
//   const combinedNames = trainerNames.join(",");
//   return combinedNames;
// }
function preTestScore(trainees) {
  if (trainees?.FalsePreQuestion !== null) {
    return (
      ((trainees.TruePreQuestion / trainees.totalAssessment) * 100).toFixed(2) +
      "%"
    );
  } else {
    return "Not Solved";
  }
}
function postTestScore(trainees) {
  if (trainees.FalsePostQuestion != null) {
    return (
      ((trainees.TruePostQuestion / trainees.totalAssessment) * 100).toFixed(
        2
      ) + "%"
    );
  } else {
    return "Not Solved";
  }
}
function exhibitedBehavior(trainees) {
  if (trainees.TruePostQuestion > trainees.TruePreQuestion) {
    return "YES";
  } else {
    return "NO";
  }
}
function dateFormate(date) {
  if (moment(date, "DD-MM-YYYY", true).isValid()) {
    return date;
  }
  return moment(date).format("DD-MM-YYYY");
}
